module.exports = "/images/circle-marker-blue.png?abc2c7e0609802264bbf87be86a146f9";